import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  Stack,
  Text,
} from '@eluve/components';
import { getFormattedDateInMMMMdyyyyWithTime } from '@eluve/date-utils';

export const AmendmentFlag: React.FC = () => (
  <Stack
    className="size-5 rounded-md bg-bg-orange-strong text-text-orange-strong"
    fullWidth={false}
    align="center"
    justify="center"
  >
    <Icon name="FlagTriangleRight" size="sm" />
  </Stack>
);

export const AmendmentHeader: React.FC<{
  date: string;
  userName: string;
  isReadonly: boolean;
  onDelete?: () => void;
  onDuplicate?: () => void;
  duplicateSectionLabel?: string;
}> = ({
  duplicateSectionLabel = '',
  date,
  userName,
  isReadonly = true,
  onDuplicate,
  onDelete,
}) => {
  const signature = `${getFormattedDateInMMMMdyyyyWithTime(date ? new Date(date) : new Date())} by ${userName}`;
  return (
    <Stack justify="between" gap={2} direction="horizontal">
      <Stack className="sm:flex-row" gap={1}>
        <Stack fullWidth={false} gap={2} direction="horizontal">
          <AmendmentFlag />
          <Text>Amendment</Text>
        </Stack>
        <Text className="text-nowrap">
          <span className="hidden text-text-tertiary sm:inline">{' • '}</span>
          <span className="text-text-tertiary">{signature}</span>
        </Text>
      </Stack>
      {!isReadonly && (
        <Stack justify="end" gap={2} direction="horizontal">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm">
                <Icon name="Ellipsis" size="auto" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              {onDelete && (
                <DropdownMenuItem onSelect={onDelete}>
                  Delete Amendment
                </DropdownMenuItem>
              )}
              {onDuplicate && (
                <DropdownMenuItem onSelect={onDuplicate}>
                  Duplicate {duplicateSectionLabel} Section
                </DropdownMenuItem>
              )}
            </DropdownMenuContent>
          </DropdownMenu>
        </Stack>
      )}
    </Stack>
  );
};
